(function () {
  if (window.__VIDEO_GALLERY_INIT__) {
    return;
  }
  window.__VIDEO_GALLERY_INIT__ = true;

  const MAX_API_RETRIES = 10;
  const API_RETRY_INTERVAL = 500;
  const boundMedia = new WeakSet();

  function loadYouTubeAPI() {
    if (window.TFP_YOUTUBE_LOADED) {
      return;
    }
    window.TFP_YOUTUBE_LOADED = true;
    const tag = document.createElement("script");
    const [first] = document.getElementsByTagName("script");
    tag.src = "https://www.youtube.com/player_api";
    first.parentNode.insertBefore(tag, first);
  }

  function loadVimeoAPI() {
    if (window.TFP_VIMEO_LOADED) {
      return;
    }
    window.TFP_VIMEO_LOADED = true;
    const tag = document.createElement("script");
    const [first] = document.getElementsByTagName("script");
    tag.src = "https://player.vimeo.com/api/player.js";
    first.parentNode.insertBefore(tag, first);
  }

  function pauseOthersInSection(section, exceptElement) {
    section.querySelectorAll(".js-youtube").forEach((iframe) => {
      if (iframe !== exceptElement && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*",
        );
      }
    });

    section.querySelectorAll(".js-vimeo").forEach((iframe) => {
      if (iframe !== exceptElement && iframe.contentWindow) {
        iframe.contentWindow.postMessage('{"method":"pause"}', "*");
      }
    });

    section.querySelectorAll("video").forEach((video) => {
      if (video !== exceptElement) {
        video.pause();
      }
    });
  }

  function bindYouTubePlayer(iframe, attempt) {
    if (boundMedia.has(iframe)) {
      return;
    }

    attempt = attempt || 1;

    if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
      loadYouTubeAPI();
      if (attempt < MAX_API_RETRIES) {
        setTimeout(() => bindYouTubePlayer(iframe, attempt + 1), API_RETRY_INTERVAL);
      }
      return;
    }

    boundMedia.add(iframe);

    if (!iframe.id) {
      iframe.id = "yt-gallery-" + Math.random().toString(36).slice(2, 9);
    }

    new YT.Player(iframe.id, {
      events: {
        onStateChange: (event) => {
          if (event.data === YT.PlayerState.PLAYING) {
            const playerIframe = event.target.getIframe();
            const section = playerIframe.closest(".section-video-gallery");
            if (section) {
              pauseOthersInSection(section, playerIframe);
            }
          }
        },
      },
    });
  }

  function bindVimeoPlayer(iframe, attempt) {
    if (boundMedia.has(iframe)) {
      return;
    }

    attempt = attempt || 1;

    if (typeof Vimeo === "undefined" || typeof Vimeo.Player === "undefined") {
      loadVimeoAPI();
      if (attempt < MAX_API_RETRIES) {
        setTimeout(() => bindVimeoPlayer(iframe, attempt + 1), API_RETRY_INTERVAL);
      }
      return;
    }

    boundMedia.add(iframe);

    const player = new Vimeo.Player(iframe);
    player.on("play", () => {
      const section = iframe.closest(".section-video-gallery");
      if (section) {
        pauseOthersInSection(section, iframe);
      }
    });
  }

  // When any native <video> starts playing — including from native controls
  // after the overlay is long gone — pause every other video in the gallery.
  document.addEventListener(
    "play",
    (event) => {
      if (!(event.target instanceof HTMLVideoElement)) {
        return;
      }

      const section = event.target.closest(".section-video-gallery");
      if (!section) {
        return;
      }

      pauseOthersInSection(section, event.target);
    },
    true,
  );

  // DeferredMedia.loadContent() runs synchronously on the poster button click
  // and appends the media element before the event bubbles to document.
  // By the time this handler fires, the <video> or <iframe> is already in the DOM.
  document.addEventListener("click", (event) => {
    const posterButton = event.target.closest(
      ".section-video-gallery .deferred-media-poster",
    );
    if (!posterButton) {
      return;
    }

    const section = posterButton.closest(".section-video-gallery");
    if (!section) {
      return;
    }

    const deferredMedia = posterButton.closest("deferred-media");
    if (!deferredMedia) {
      return;
    }

    const video = deferredMedia.querySelector("video");
    const ytIframe = deferredMedia.querySelector(".js-youtube");
    const vimeoIframe = deferredMedia.querySelector(".js-vimeo");
    const currentMedia = video || ytIframe || vimeoIframe;

    pauseOthersInSection(section, currentMedia);

    if (video) {
      video.play().catch(() => {});
    } else if (ytIframe) {
      bindYouTubePlayer(ytIframe);
    } else if (vimeoIframe) {
      bindVimeoPlayer(vimeoIframe);
    }
  });
})();
